<template>
  <v-flex xs4>
    <v-switch v-model="userRole" :label="role" @change="update" class="mt-0"></v-switch>
  </v-flex>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'platform-user-security-role',
  props: ['user', 'role'],
  data: () => ({
    userRole: false
  }),
  computed: {
    ...mapGetters(['SelectedAccount'])
  },
  methods: {
    ...mapActions(['updatePlatformUserSecurityRole']),
    update: function(value) {
      this.updatePlatformUserSecurityRole({
        id: this.user.id,
        updates: {
          role: this.role,
          attach: value
        }
      });
    }
  },
  watch: {
    user: function() {
      this.userRole = _.includes(this.user.roles, this.role);
    }
  },
  mounted() {
    this.userRole = _.includes(this.user.roles, this.role);
  }
};
</script>

<style scoped></style>
